/* Layout partagé de toutes les pages d'authentification Factumis.
   Affiche : logo de marque, titre h1, sous-titre optionnel, contenu ({children}),
   et pied de page fixe mentionnant la réforme 2026. Importe auth.css. */
import type { ReactNode } from 'react';
import './auth.css';

export function AuthLayout({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-brand">Factumis</div>
        <h1 className="auth-title">{title}</h1>
        {subtitle ? <p className="auth-sub">{subtitle}</p> : null}
        {children}
      </div>
      <p className="auth-foot">
        Facturation électronique conforme, réforme 2026
      </p>
    </div>
  );
}
